/**
 * Generate random small string key
 */
export const genKey = function () {
    return Math.random().toString(36).substring(7)
}
